import { gql } from "@apollo/client";

export default gql`
  mutation deleteOrgWideCareerTrack($careerTrackId: Int!) {
    deleteCareerTrack(careerTrackId: $careerTrackId) {
      ok
    }
  }
`;
